import React from 'react';
import './Quiz.scss';
import Question from './Question/Question';
import AnswerOption from './Question/AnswerOption/AnswerOption';
import QuestionCount from './QuestionCount/QuestionCount';
import Feedback from './Feedback/Feedback';
import Config from '../../../config/config';

const Quiz = (props) => {

    const serverPath = Config.serverPath;
           // const noteName = item.img_path;
       // const note_src = noteName? `${serverPath}/api/quizesimg/${selectedQuizId}/${item.img_path}`: null; 
        const note_src = `${serverPath}/api/quizesimg/${props.quizRedux.quizId}/${props.quizRedux.questionImg}`; 



    const renderAnswerOptions =(key, idListItem) => {

        const is_selected = props.quizRedux.selectedItem === idListItem;

        const serverPath = Config.serverPath;


          return (
        <AnswerOption
            
            isSelected={is_selected}
            pointer={props.quizRedux.pointer}
            key={idListItem}
            answerContent={key.text}
            answerType={key.value}
            answer={props.quizRedux.answer}
            questionId={props.quizRedux.questionId}
 
            onAnswerSelected={props.onAnswerSelected.bind(this, idListItem)}

            styleAnswer={props.quizRedux.styleAnswer}
            number={idListItem}
            
        />
        );     
        }
    //
    const renderFeedback = () => {
            if (props.quizRedux.selectedItem) {
            return (
                <Feedback 
                feedback={props.quizRedux.answerOptions}
                isSelected={props.quizRedux.selectedItem}
            />
            )
            } else return null;
        }


        // 
    const nextQuestion = () => {
            let style;
          
           if (props.quizRedux.selectedItem != null) {
                style = ''
            } else {
                style = 'disabled'
            }
 
           //SEND NEXT SORT TYPE OF QUESTION
            return (
                <div>
                    <button onClick={props.nextQuestion.bind(this, props.quizRedux.dataQuizQuestions.length !== (props.quizRedux.counterQuestion +1) ? props.quizRedux.dataQuizQuestions[props.quizRedux.counterQuestion+1].sort_quest : 0)}  
                    disabled={style}>Следующий</button>
                </div>
            )

    }
        
    if (props.quizRedux.dataQuiz.length !== 0) {
             //const note_src = `${serverPath}/api/quizesimg/13/$q_13_1234.jpg`;
            return (

                <div className="Quiz" key={props.quizRedux.questionId}>
                    <div className="Quiz-header">
                       
                    
                        <QuestionCount 
                            counter={props.quizRedux.questionId} 
                            total={props.quizRedux.questionLength} 
                        />
                        
                        {(props.authData.modulesName[1].status || (props.authData.userRole[0].role_id === 1)) ? <button id="note-trouble"></button> : null}
                    </div>
                    
                    <Question 
                        content={props.quizRedux.question}

                    />
                     <div className='img-container'>
                           
                             {props.quizRedux.questionImg ? <img alt="note" src={note_src}/>  : null}
                           
                                
                    </div>
                    <ul className="Quiz-answerOptions" >
                        {props.quizRedux.answerOptions.map(renderAnswerOptions)}
                    </ul>
                    {renderFeedback()}
                    {nextQuestion()}
                   
                    
                </div>
              
            )
  
    } else {
         return (

                <div className="Quiz" key={props.quizRedux.questionId}>
                    <div className="Quiz-header">
                       
                    
                        <QuestionCount 
                            counter={0} 
                            total={0} 
                        />
                        
                       
                    </div>
                </div>
                    )
    }
    
}

export default Quiz;